export default __webpack_public_path__ + "static/media/cert.6f72d384.svg";